// removed by extract-text-webpack-plugin
module.exports = {"ui":"fingerprint_ui_d4h9ld"};


//////////////////
// WEBPACK FOOTER
// ./packages/lib-ui/src/img/fingerprint/fingerprint.scss
// module id = 457
// module chunks = 0